import authentication from "features/OnBoarding/authenticationSlice";
import GlobalSpinner from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import productsServices from "features/ProductsandServices/ProductsandServicesSlice";
import lookup from "CommonComponents/Lookup/LookupSlice";
import clients from "features/Clients/ClientsSlice";
import projects from "features/Projects/ProjectsSlice";
import ThirdParty from "features/ThirdParty/ThirdPartySlice";
import employees from "features/Admin/Employees/EmployeesSlice";
import taskTemplate from "features/Admin/TaskTemplate/TaskTemplateSlice";
import leads from "features/Leads/LeadsSlice";
import Attachments from "CommonComponents/Attachments/AttachmentsSlice";
import quotes from "features/Quotes/QuotesSlice";
import appointments from "features/Clients/Appointments/AppointmentSlice";
import invoices from "features/Invoices/InvoicesSlice";
import dispatch from "features/Dispatch/DispatchSlice";
import subContractor from "features/Admin/SubContractor/SubContractorSlice";
//Include all the reducer to combine and provide to configure store.

const rootReducer = {
  authentication,
  GlobalSpinner,
  productsServices,
  lookup,
  employees,
  clients,
  projects,
  ThirdParty,
  leads,
  taskTemplate,
  Attachments,
  quotes,
  appointments,
  invoices,
  dispatch,
  subContractor,
};
export default rootReducer;
